// Configuration d'environnement chargée au runtime (fichier public/env.json),
// indépendante du build. Permet de déployer le même build chez plusieurs clients
// en changeant simplement ce fichier après compilation.
export const cca_config = {}

let loadPromise = null

export function loadcca_config() {
    if (!loadPromise) {
        loadPromise = fetch(`${process.env.BASE_URL}env.json`)
            .then(response => response.json())
            .then(data => Object.assign(cca_config, data))
            .catch(error => {
                console.error('Impossible de charger la configuration (env.json) :', error)
            })
    }
    return loadPromise
}
